<div
  class="export"
  [attr.tabindex]="disabled ? -1 : 0"
  role="button"
  aria-label="Export"
  (click)="onExport()"
  (keydown.enter)="onExport()"
  [ngClass]="{ 'export--loading': isLoading, 'export--disabled': disabled}"
  [attr.data-qa]="testId"
>
  <rx-icon *ngIf="!isLoading; else loadingInProgress" class="export__icon" name="export" size="md" />
  <span class="export__label">{{ label }}</span>
</div>

<ng-template #loadingInProgress>
  <rx-applications-input-loading class="export__icon" #loadingInProgress [small]="true" [centered]="true" />
</ng-template>
